export default "__VITE_ASSET__b689c0cd__"